import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { MemberSubscription } from '../../types/user';

const initialState: MemberSubscription = {
  messagesLimit: 0,
  messagesRemaining: 0,
  status: '',
  _id: '',
  subscriptionId: '',
  customerId: '',
  memberId: '',
  productId: '',
  firstPaymentId: '',
  startDate: '',
  endDate: '',
  createdAt: '',
  updatedAt: '',
  amount: 0,
  priceId: ''
};

export const memberSubscriptionSlice = createSlice({
  name: 'memberSubscription',
  initialState,
  reducers: {
    setMemberSubscription: (_, action: PayloadAction<MemberSubscription>) => {
      return action.payload;
    },
    clearMemberSubscription: () => initialState,
  },
});

export const { setMemberSubscription, clearMemberSubscription } = memberSubscriptionSlice.actions;
export default memberSubscriptionSlice.reducer;
